<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div  class="kt-portlet kt-portlet--mobile">
      <div  class="kt-portlet__body">
          <div  >
              <div  class="kt-portlet__head pl-0 pr-0">
                  <div  class="kt-portlet__head-toolbar">
                      <div  class="kt-portlet__head-wrapper">
                          <div  class="dropdown dropdown-inline">
                              <button    data-target="#GameModal" class="btn btn-brand btn-icon-sm"><i   class="fas fa-plus"></i>Create
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
              <div  class="kt-form kt-form--label-right kt-margin-t-20 kt-margin-b-10">
                  <div  class="row align-items-center">
                      <div  class="col-xl-12 order-2 order-xl-1">
                          <div  class="row align-items-center">

                          </div>
                          <div  class="row align-items-center">
                              <div  class="col-md-3 kt-margin-b-20-tablet-and-mobile">
                                  <div  class="kt-input-icon kt-input-icon&amp;#45;&amp;#45;left">
                                      <form >
                                          <input  type="text" placeholder="Search" class="form-control">
                                      </form>
                                  </div>
                              </div>
                              <div  class="col-md-3 kt-margin-b-20-tablet-and-mobile">
                                  <div  class="kt-form__group kt-form__group--inline">
                                      <div  class="kt-form__label">
                                          <label>Status:</label>
                                      </div>
                                      <div  class="kt-form__control">
                                          <select  class="form-control">
                                              <option  value="0">
                                                  Inactive
                                              </option>
                                              <option  value="1">
                                                  Active
                                              </option>
                                              <option  value="all">
                                                  All
                                              </option>
                                          </select>
                                      </div>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div  class="kt-section">
              <div  class="kt-section__content">
                  <div  class="table-responsive">
                      <table  class="table table-bordered table-hover table-striped">
                          <thead>
                              <tr>
                                  <th >Platform</th>
                                  <th >Platform Category</th>
                                  <th >Game Category</th>
                                  <th >Game Identifier</th>
                                  <th  class="text-center">Status</th>
                                  <th  class="text-center">Actions</th>
                              </tr>
                          </thead>
                          <tbody>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >AAAA</td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >EP02 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >EP03 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >FRU </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >FRU2 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >HUNTER</td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >PK_J </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >PKBB </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >PKBD </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >PKBJ </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB01 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB02 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB03 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB04 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB05 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB06 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB07 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB08 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB09 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr>
                                  <td >AG Gaming</td>
                                  <td >Slots</td>
                                  <td >TOP</td>
                                  <td >SB10 </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button   data-target="#GameModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button   data-target="#GameDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                          </tbody>
                      </table>
                      <div  class="kt-pagination  kt-pagination--brand">
                          <ul class="kt-pagination__links">
                              <li class="kt-pagination__link--first"><a><i class="fa fa-angle-double-left kt-font-brand"></i></a></li>
                              <li class="kt-pagination__link--next"><a><i class="fa fa-angle-left kt-font-brand"></i></a></li>
                              <li class="kt-pagination__link--active"><a>1</a></li>
                              <li class=""><a>2</a></li>
                              <li class=""><a>3</a></li>
                              <li class=""><a>4</a></li>
                              <li class=""><a>5</a></li>
                              <li class="kt-pagination__link--prev"><a><i class="fa fa-angle-right kt-font-brand"></i></a></li>
                              <li class="kt-pagination__link--last"><a><i class="fa fa-angle-double-right kt-font-brand"></i></a></li>
                          </ul>
                          <div class="kt-pagination__toolbar">
                              <select class="form-control kt-font-brand" style="width: 60px;">
                                  <option value="10">10</option>
                                  <option value="20" selected="selected">20</option>
                                  <option value="30">30</option>
                                  <option value="50">50</option>
                              </select> <span class="pagination__desc">
          Showing 1 to 20 of 284 records
      </span></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div    tabindex="-1" role="dialog" aria-hidden="true" class="modal fade" id="GameModal">
          <div  role="document" class="modal-dialog modal-lg">
              <div  class="modal-content">
                  <div  class="modal-header">
                      <h5 class="modal-title">Create</h5>
                  </div>
                  <div  class="modal-body">
                      <div  >

                          <div   class="form-group row required">
                              <label   class="col-lg-4 control-label text-right">Platform:</label>
                              <select    class="col-lg-8 form-control">
                                  <option   value="1">
                                      AG Gaming
                                  </option>
                                  <option   value="2">
                                      XE88
                                  </option>
                                  <option   value="3">
                                      Playtech
                                  </option>
                                  <option   value="4">
                                      ST996
                                  </option>
                                  <option   value="5">
                                      ACE333
                                  </option>
                                  <option   value="6">
                                      FGG
                                  </option>
                                  <option   value="7">
                                      Sexy Baccarat
                                  </option>
                                  <option   value="8">
                                      ABSLotto
                                  </option>
                                  <option   value="9">
                                      Spade Gaming
                                  </option>
                                  <option   value="10">
                                      Pragmatic Play
                                  </option>
                                  <option   value="11">
                                      Gaming World
                                  </option>
                                  <option   value="12">
                                      AllBet
                                  </option>
                                  <option   value="13">
                                      MAXBET
                                  </option>
                              </select>
                          </div>

                          <div   class="form-group row required">
                              <label   class="col-lg-4 control-label text-right">Game Category:</label>
                              <select    class="col-lg-8 form-control">
                                  <option   value="1">
                                      DEFAULT
                                  </option>
                                  <option   value="2">
                                      TOP
                                  </option>
                                  <option   value="3">
                                      NEW
                                  </option>
                                  <option   value="4">
                                      HOT
                                  </option>
                                  <option   value="5">
                                      POPULAR
                                  </option>
                              </select>
                          </div>
                          <div   class="form-group row required">
                              <label   class="col-lg-4 control-label text-right">Game Identifier:</label>
                              <input   type="text" name="remarks" class="col-lg-8 form-control">
                          </div>
                      </div>
                  </div>
                  <div  class="modal-footer">
                      <button   type="button" data-dismiss="modal" class="btn btn-secondary">
                          Close
                      </button>
                      <button   type="button" data-dismiss="modal" class="btn btn-primary">
                          Save
                      </button>
                  </div>
              </div>
          </div>
      </div>
      <div    tabindex="-1" role="dialog" aria-hidden="true" class="modal fade" id="GameDetailModal">
          <div  role="document" class="modal-dialog modal-lg">
              <div  class="modal-content">
                  <div  class="modal-header">
                      <h5 class="modal-title">Create</h5>
                  </div>
                  <div  class="modal-body"></div>
                  <div  class="modal-footer">
                      <button   type="button" data-dismiss="modal" class="btn btn-secondary">
                          Close
                      </button>
                      <button   type="button" data-dismiss="modal" class="btn btn-primary">
                          Save
                      </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
